export default __webpack_public_path__ + "static/media/staffordville4.be172cd1.png";